import api from './data.services'
import { authService } from '.'

const interventionsSrv = 'budgets/requests/types/interventions'
const forecastSrv = 'budgets/requests/forecasts'
const treatingsPhysiciansSrv = 'budgets/requests/treatings/physicians'
const budgetsRequestedSrv = 'budgets/requests/pages'
const postBudgetsRequestedSrv = 'budgets/requests'

const getInterventions = async () => {
  try {
    const resp: any = await api.get(interventionsSrv, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.typeInterventions ? resp.data.typeInterventions : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener tipo de intervenciones!'
    }
  }
}

const getForecasts = async () => {
  try {
    const resp: any = await api.get(forecastSrv)

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.forecasts ? resp.data.forecasts : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener Previsiones!'
    }
  }
}

const getTreatingsPhysicians = async () => {
  try {
    const resp: any = await api.get(treatingsPhysiciansSrv, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.treatingPhysicians ? resp.data.treatingPhysicians : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener médicos tratantes!'
    }
  }
}

const getBudgetsRequested = async (id?: string) => {
  try {
    const resp: any = await api.get(`${budgetsRequestedSrv}${id ? '/' + id : ''}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.requestBudgets ? resp.data.requestBudgets : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener presupuestos solicitados!'
    }
  }
}

const postBudgetRequest = async (data: any, id: string = '') => {
  try {
    const resp: any = await api.post(`${postBudgetsRequestedSrv}${id ? '/' + id : ''}`, data, authService.getToken())

    return {
      status: (resp && resp.data && typeof resp.data.budgetRequestId === 'number' ? 'Ok' : 'Error'),
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al guardar solicitud de presupuestos!'
    }
  }
}

export const requestService = {
  getInterventions,
  getForecasts,
  getTreatingsPhysicians,
  getBudgetsRequested,
  postBudgetRequest
}